import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Plus, Pencil, Trash2 } from 'lucide-react'
import { supabase } from '../supabaseClient'
import ConfirmModal from '../components-admin/ConfirmModal'

export default function BlogListPageAdmin() {
  const [posts, setPosts] = useState([])
  const [loading, setLoading] = useState(true)
  const [deleteId, setDeleteId] = useState(null)

  const fetchPosts = async () => {
    setLoading(true)
    const { data, error } = await supabase.from('posts').select('*').order('created_at', { ascending: false })
    if (error) {
      console.error('Erro ao buscar posts:', error)
    }
    if (!error) setPosts(data || [])
    setLoading(false)
  }

  const handleDelete = async () => {
    if (!deleteId) return
    await supabase.from('posts').delete().eq('id', deleteId)
    setDeleteId(null)
    fetchPosts()
  }

  useEffect(() => { fetchPosts() }, [])

  const statusBadge = (status) => {
    if (status === 'published') return 'bg-emerald-50 text-emerald-700 border-emerald-200'
    if (status === 'scheduled') return 'bg-amber-50 text-amber-700 border-amber-200'
    return 'bg-gray-50 text-gray-600 border-gray-200'
  }

  const statusLabel = (status) => {
    if (status === 'published') return 'Publicado'
    if (status === 'scheduled') return 'Agendado'
    return 'Rascunho'
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-extrabold font-display text-gray-900">Blog</h1>
        <Link to="/admin/blog/new" className="inline-flex items-center gap-2 rounded-lg bg-[#bef102] px-4 py-2 text-sm font-bold text-[#0d1f12] hover:bg-[#a8d800] transition-colors">
          <Plus size={16} /> Nova matéria
        </Link>
      </div>

      <div className="overflow-x-auto rounded-xl border border-gray-200 bg-white shadow-sm">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-gray-200 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">
              <th className="px-4 py-3">Título</th>
              <th className="px-4 py-3">Status</th>
              <th className="px-4 py-3">Data de criação</th>
              <th className="px-4 py-3">Publicação</th>
              <th className="px-4 py-3 text-right">Ações</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {loading ? (
              <tr><td colSpan={5} className="px-4 py-6 text-center text-gray-400">Carregando…</td></tr>
            ) : posts.length === 0 ? (
              <tr><td colSpan={5} className="px-4 py-6 text-center text-gray-400">Nenhuma matéria cadastrada.</td></tr>
            ) : posts.map((p) => (
              <tr key={p.id} className="hover:bg-gray-50 transition-colors">
                <td className="px-4 py-3 text-gray-900 font-medium">{p.title}</td>
                <td className="px-4 py-3">
                  <span className={`inline-flex rounded-full px-2.5 py-0.5 text-xs font-semibold border ${statusBadge(p.status)}`}>
                    {statusLabel(p.status)}
                  </span>
                </td>
                <td className="px-4 py-3 text-gray-500">{new Date(p.created_at).toLocaleDateString('pt-BR')}</td>
                <td className="px-4 py-3 text-gray-500">{p.published_at ? new Date(p.published_at).toLocaleDateString('pt-BR') : '—'}</td>
                <td className="px-4 py-3 text-right">
                  <div className="flex items-center justify-end gap-2">
                    <Link to={`/admin/blog/edit/${p.id}`} className="rounded-md p-1.5 text-gray-400 hover:bg-gray-100 hover:text-gray-900 transition-colors">
                      <Pencil size={15} />
                    </Link>
                    <button onClick={() => setDeleteId(p.id)} className="rounded-md p-1.5 text-gray-400 hover:bg-red-50 hover:text-red-600 transition-colors">
                      <Trash2 size={15} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <ConfirmModal
        open={!!deleteId}
        title="Excluir matéria"
        message="Tem certeza que deseja excluir esta matéria? Esta ação não pode ser desfeita."
        onConfirm={handleDelete}
        onCancel={() => setDeleteId(null)}
      />
    </div>
  )
}
